import React, {
  useState,
  //  useCallback,
  useEffect,
} from 'react';
import TextField from '@material-ui/core/TextField';
import { Controller } from 'react-hook-form';
import { Autocomplete, Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'dva';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import { useLocation, useIntl } from 'umi';
import ChangeLevelStyled from './ChangeLevelStyled';
const ChangeLevel = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const location = useLocation();
  const { query } = location;
  const { valueBefore, opt, value, remark } = query;
  const { control, setValue, errors } = props;
  const dispatch = useDispatch();
  const [level, setLevel] = useState(null);
  const [reason, setReason] = useState('');
  const datas = useSelector((state) => state.adjustDetail.memberDetail);
  const levels = useSelector((state) => state.adjustList.levels);
  useEffect(() => {
    if (datas && !opt) {
      setValue('preLevel', datas.level);
    }
  }, [datas, opt, setValue]);
  useEffect(() => {
    if (opt === 'preview') {
      setValue('preLevel', valueBefore);
      const newLevel = levels.find((i) => i.code === Number(value));
      console.log('newLevel', newLevel);
      setValue('level', newLevel?.code);

      setLevel(newLevel);
      setValue('reason', remark);
    }
  }, [valueBefore, levels, opt, remark, setValue, value]);
  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'adjustList/getLevels' });
  }, [dispatch]);
  return (
    <ChangeLevelStyled>
      <Box width={360}>
        <Controller
          as={<TextField />}
          name="preLevel"
          variant="standard"
          className="member-level"
          label={formatMessage({ id: 'adjustment.members.level.n02.lbl01' })}
          control={control}
          disabled
          id="basic"
          defaultValue={''}
        />
      </Box>
      <Box width={360} mt={4}>
        <Controller
          name="level"
          control={control}
          rules={{
            required: true,
          }}
          error={Boolean(errors.level)}
          render={() => (
            <Autocomplete
              disabled={opt === 'preview'}
              id="clear-on-blur"
              options={levels}
              name="level"
              onChange={(e, newValue) => {
                setValue('level', newValue);
                setLevel(newValue);
              }}
              value={level}
              getOptionLabel={(option) => option.name}
              clearOnBlur
              renderInput={(param) => (
                <TextField
                  {...param}
                  name="level"
                  label={
                    <span>
                      <span className="red">*</span>
                      {formatMessage({
                        id: 'adjustment.members.level.n02.lbl02',
                      })}
                    </span>
                  }
                  variant="standard"
                  rules={{
                    required: true,
                  }}
                  helperText={
                    Boolean(errors.level) &&
                    formatMessage({ id: 'adjustment.members.level.n01.rdo01' })
                  }
                  error={Boolean(errors.level)}
                />
              )}
            />
          )}
        ></Controller>
      </Box>
      <Box width={360} mt={4} className="reason">
        <Controller
          rules={{
            required: true,
          }}
          error={Boolean(errors.reason)}
          render={(rp) => (
            <TextField
              value={rp.value ?? reason}
              disabled={opt === 'preview'}
              onChange={(e) => {
                setValue('reason', e.target.value);
                setReason(e.target.value);
                return rp.value;
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {}}
                      edge="end"
                    >
                      {reason ? <ClearIcon className="clear-icon" /> : ''}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="standard"
              className="input"
              rules={{
                required: true,
              }}
              helperText={
                Boolean(errors.reason) &&
                formatMessage({ id: 'adjustment.members.level.n01.lbl02' })
              }
              error={Boolean(errors.reason)}
              label={formatMessage({
                id: 'adjustment.members.level.n02.lbl03',
              })}
            />
          )}
          name="reason"
          control={control}
          id="basic"
          defaultValue=""
        />
      </Box>
    </ChangeLevelStyled>
  );
};
export default ChangeLevel;
